import PropTypes from 'prop-types'
import media from '../../../types/mediaForm'

export const propTypes = {
    countries: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
        })
    ).isRequired,
    clearForm: PropTypes.func.isRequired,
    createContentPush: PropTypes.func.isRequired,
    editContentPush: PropTypes.func.isRequired,
    editFormField: PropTypes.func.isRequired,
    error: PropTypes.string,
    estates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    fetchPlaylists: PropTypes.func.isRequired,
    form: PropTypes.shape({
        countries: PropTypes.arrayOf(PropTypes.string),
        date_end: PropTypes.number,
        date_start: PropTypes.number,
        group: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
        level_required: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
        media: PropTypes.oneOfType([PropTypes.shape(media), PropTypes.arrayOf(PropTypes.instanceOf(File))]),
        name: PropTypes.string,
        notes: PropTypes.string,
        purchase_order: PropTypes.string,
    }),
    isWorking: PropTypes.bool.isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }).isRequired,
    notify: PropTypes.func.isRequired,
    history: PropTypes.shape({
        goBack: PropTypes.func,
    }).isRequired,
    playlists: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectEstate: PropTypes.func.isRequired,
    selectedEstate: PropTypes.string.isRequired,
    showContentPush: PropTypes.func.isRequired,
    uploadMedia: PropTypes.func.isRequired,
}

export const defaultProps = {
    error: null,
    form: {},
}
